import React from 'react';
import Button from '@mui/material/Button';
import { CustomDialog } from 'components/CustomDialog';
import { Stack } from '@mui/material';
import { ButtonContained } from 'components/Button';

interface ConfirmLeavingDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const ConfirmLeavingDialog = ({ open, onClose, onSubmit }: ConfirmLeavingDialogProps) => (
  <CustomDialog
    open={open}
    title="¿Está seguro de que desea abandonar la página?"
    maxWidth="md"
    onClose={onClose}
    bodyChildren={
      <Stack gap="10px" width="100%">
        <ButtonContained size="medium" onClick={onClose} label="No, quedarme y continuar el registro" />
        <Button color="primary" fullWidth onClick={onSubmit}>
          Sí, abandonar la página
        </Button>
      </Stack>
    }
  />
);
